import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { NotificationResponse } from '../../server/response/responseSchema';
import { apiClient } from '../clientUtils/apiClient';
import webViewStore from './webViewStore';

class NotificationStore {
    notifications: NotificationResponse[] = [];
    isLoading = false;
    hasUnreadNotifications = false;

    constructor() {
        makeAutoObservable(this);
    }

    async fetchNotifications() {
        this.isLoading = true;

        try {
            // 알림 목록 가져오기
            this.notifications = await apiClient.notification.member.getNotifications.query();

            // 모든 알림을 읽음 처리
            await apiClient.notification.member.markAsRead.mutate();

            runInAction(() => {
                this.hasUnreadNotifications = false;
            });

            // 다른 웹뷰에도 알림 읽음 전파
            webViewStore.syncUi('notificationMarkAsRead', {});
        } catch (error) {
            console.error('Failed to fetch notifications:', error);
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    async checkHasUnreadNotifications() {
        const hasUnread = await apiClient.notification.member.hasUnread.query();

        runInAction(() => {
            this.hasUnreadNotifications = hasUnread;
        });
    }

    /**
     * 읽지 않은 알림 뱃지 제거
     * - 웹뷰 UI 동기화에서 사용됨
     */
    clearHasUnreadNotifications() {
        this.hasUnreadNotifications = false;
    }

    async markAsClicked(notification: NotificationResponse) {
        try {
            // 알림 클릭 처리
            await apiClient.notification.member.markAsClicked.mutate({
                notificationHash: notification.hash,
            });

            // 클릭한 알림으로 상태 업데이트
            const index = this.notifications.findIndex((n) => n.hash === notification.hash);
            if (index !== -1) {
                runInAction(() => {
                    this.notifications[index] = {
                        ...notification,
                        isClicked: true,
                    };
                });
            }
        } catch (error) {
            console.error('Failed to mark notification as clicked:', error);
        }
    }
}

export default new NotificationStore();
